module.exports = __webpack_public_path__ + "fonts/SteelfishRg-Italic.97e1a512.woff";